import styled from "styled-components";
import { useRef, useEffect, type RefObject, } from "react";
import { getTheme, } from "@bracket/ui/themes";
import { getTabularRasaStore, type ComputedRasaColumnOptions, } from "../RasaStore";
import { RasaHeaderCell, } from "./RasaHeaderCell";
import { Stream, } from "@bracket/ui/nodes";



export declare type RasaHeaderRowProps<T extends Record<string, any>> = {
	id: string;
	debug?: boolean;
};


export const RasaHeaderRow = <T extends Record<string, any>>({
	id,
	debug,
}: RasaHeaderRowProps<T> ) => {

	const { rowMargin, rowPadding, headerRowMargin, headerRowPadding, columnKeys, _bindRefs, } = getTabularRasaStore(id)();
	const headerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if(headerRef.current) {
			_bindRefs(headerRef as RefObject<HTMLDivElement>);
		}
	}, [headerRef.current]);

	return (
		<TRHeaderRow
			ref={headerRef}
			$rowMargin={rowMargin}
			$rowPadding={rowPadding}
			$headerRowMargin={headerRowMargin}
			$headerRowPadding={headerRowPadding}
			$debug={debug}>
		{
			Array.from(columnKeys.entries()).map(([key, column]) => {
				if(column.hidden) return null;
				const params = Object.entries(column).reduce((acc, [key, value]) =>
					key.startsWith("$") ? { ...acc, [key]: value } : acc, {} as ComputedRasaColumnOptions<T>
				) as ComputedRasaColumnOptions<T>;
				return <RasaHeaderCell id={id} key={key} field={key} {...params} />;
			})
		}
		</TRHeaderRow>
	)
};


const TRRow = styled(Stream)<{ $rowMargin?: string; $rowPadding?: string; }>`
	${({ $rowMargin }) => `margin: ${$rowMargin}` || ""};
	${({ $rowPadding }) => `padding: ${$rowPadding}` || ""};
`;

const TRHeaderRow = styled(TRRow)<{ $headerRowMargin?: string; $headerRowPadding?: string; }>`
	${({ $headerRowMargin }) => `margin: ${$headerRowMargin}` || ""};
	${({ $headerRowPadding }) => `padding: ${$headerRowPadding}` || ""};
	border-bottom: 1px solid ${() => getTheme().surface_container_high};
	padding: 10px 16 10px 16;
	color: ${() => getTheme().surface_on};
	@media (max-width: 768px) {
		display: none;
	}
`;
